import { JobAlertUI } from './JobAlertUI';

export class CommonJobAlert{

    public jobAlert: JobAlertUI = new JobAlertUI();

}